import { supabase } from "../supabase";

export const BILLING_STATUS = Object.freeze({
  NONE: "none",
  TRIALING: "trialing",
  ACTIVE: "active",
  PAST_DUE: "past_due",
  CANCELED: "canceled",
});

export const DEFAULT_BILLING_SNAPSHOT = Object.freeze({
  status: BILLING_STATUS.NONE,
  plan_key: null,
  seat_limit: null,
  trial_ends_at: null,
  current_period_end: null,
  billing_provider: null,
});

/**
 * Read-only billing snapshot for admin display. No payment enforcement in RC.
 * Returns DEFAULT_BILLING_SNAPSHOT when row is absent or table not yet migrated.
 */
export async function loadOrganizationBillingSnapshot(
  organizationId,
  client = supabase,
) {
  if (!organizationId) {
    return { ...DEFAULT_BILLING_SNAPSHOT };
  }

  const { data, error } = await client
    .from("organization_billing")
    .select(
      "status, plan_key, seat_limit, trial_ends_at, current_period_end, billing_provider",
    )
    .eq("organization_id", organizationId)
    .maybeSingle();

  if (error) {
    if (error.code === "42P01") {
      return { ...DEFAULT_BILLING_SNAPSHOT, _tableMissing: true };
    }
    console.warn("[organizationBilling] load failed", error);
    return { ...DEFAULT_BILLING_SNAPSHOT, _error: error.message };
  }

  if (!data) {
    return { ...DEFAULT_BILLING_SNAPSHOT };
  }

  return {
    status: data.status || BILLING_STATUS.NONE,
    plan_key: data.plan_key ?? null,
    seat_limit: data.seat_limit ?? null,
    trial_ends_at: data.trial_ends_at ?? null,
    current_period_end: data.current_period_end ?? null,
    billing_provider: data.billing_provider ?? null,
  };
}

export function formatBillingStatusLabel(status) {
  switch (status) {
    case BILLING_STATUS.TRIALING:
      return "Trial";
    case BILLING_STATUS.ACTIVE:
      return "Active";
    case BILLING_STATUS.PAST_DUE:
      return "Past due";
    case BILLING_STATUS.CANCELED:
      return "Canceled";
    default:
      return "Early access";
  }
}
